
import React, { useEffect, useState } from "react";
import "./header.css";
import logo from "../../assets/redite-logo.png";
import AOS from "aos";
import "aos/dist/aos.css";

function Header() {
  // ---------------- FORM STATES ----------------
  const [formData, setFormData] = useState({
    name: "",
    email: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  // Handle input
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    try {
      const response = await fetch("https://sales.redite.in/php/sendemail.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      console.log("Server Response:", result);

      if (result.success) {
        setStatus("Mail sent successfully ✔");

        // Reset form
        setFormData({
          name: "",
          email: "",
        });
      } else {
        setStatus("Failed to send mail ❌");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setStatus("Error sending mail ❌");
    }

    setLoading(false);
  };

  // ---------------- COUNTERS ----------------
  const [projects, setProjects] = useState(0);
  const [clients, setClients] = useState(0);
  const [awards, setAwards] = useState(0);

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });

    // Counters animation
    let p = 0,
      c = 0,
      a = 0;

    const interval = setInterval(() => {
      if (p < 129) p++;
      if (c < 102) c++;
      if (a < 23) a++;

      setProjects(p);
      setClients(c);
      setAwards(a);

      if (p === 129 && c === 102 && a === 23) {
        clearInterval(interval);
      }
    }, 20);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <header className="header-section">
        <div className="overlay-header"></div>

        <div className="header-container">
          {/* Left Content with AOS */}
          <div className="header-content" data-aos="fade-up">
            <img src={logo} width={154} height={54} alt="Redite Logo" />

            <h3>
              Welcome to <span className="color-change">Redite </span> – Your Web Design Partner
            </h3>

            <p className="sub-text">
              At Redite, we turn your ideas into reality with expert design, development, and marketing solutions.
              Whether you’re launching a new business or enhancing your digital presence, we’re here to make it happen.
            </p>

            {/* ------------ FORM (Name + Email Only) ------------ */}
            <form className="hero-form" onSubmit={handleSubmit} data-aos="fade-up" data-aos-delay="200">
              <input
                type="text"
                name="name"
                placeholder="Name"
                required
                value={formData.name}
                onChange={handleChange}
              />

              <input
                type="email"
                name="email"
                placeholder="Email"
                required
                value={formData.email}
                onChange={handleChange}
              />

              <button type="submit" disabled={loading}>
                {loading ? "Sending..." : "Send"}
              </button>

              {status && <p className="status-msg">{status}</p>}
            </form>
          </div>
        </div>
      </header>

      {/* ----------------- COUNTERS SECTION ----------------- */}
      <section className="container">
        <div className="vision-section">
          {/* TEXT BOX */}
          <div className="vision-box" data-aos="fade-up">
            <h2 className="vision-title">
              Transform Your Vision into <br />
              <span className="vision-highlight">A Stunning Digital Experience</span>
            </h2>

            <div className="underline">
              <svg viewBox="0 0 500 150" preserveAspectRatio="none">
                <path d="M3,146.1c17.1-8.8,33.5-17.8,51.4-17.8c15.6,0,17.1,18.1,30.2,18.1c22.9,0,36-18.6,53.9-18.6 
                  c17.1,0,21.3,18.5,37.5,18.5c21.3,0,31.8-18.6,49-18.6c22.1,0,18.8,18.8,36.8,18.8c18.8,0,37.5-18.6,49-18.6
                  c20.4,0,17.1,19,36.8,19c22.9,0,36.8-20.6,54.7-18.6c17.7,1.4,7.1,19.5,33.5,18.8c17.1,0,47.2-6.5,61.1-15.6">
                </path>
              </svg>
            </div>
          </div>

          {/* COUNTERS */}
          <div className="stats-container">
            <div className="stat-box" data-aos="fade-up" data-aos-delay="100">
              <h2 className="stat-number">{projects}</h2>
              <p>PROJECTS</p>
            </div>

            <div className="stat-box" data-aos="fade-up" data-aos-delay="200">
              <h2 className="stat-number">{clients}</h2>
              <p>HAPPY CLIENTS</p>
            </div>

            <div className="stat-box" data-aos="fade-up" data-aos-delay="300">
              <h2 className="stat-number">{awards}</h2>
              <p>AWARDS</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Header;
